import { Component, OnInit, OnDestroy } from '@angular/core';
import { Patient } from '@app/shared/models';
import { PrintService } from '@app/shared/services/helpers/print.service';
import { environment } from '@env/environment';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-ppds-informed-consent-waiver',
    templateUrl: './ppds-informed-consent-waiver.component.html',
    styleUrls: ['./ppds-informed-consent-waiver.component.scss']
})
export class PpdsInformedConsentWaiverComponent implements OnInit, OnDestroy {

    base_url: string = environment.apiUrl;
    patient: Patient;
    assessment: any;
    assessJSON: any;
    assessmentItems: any;

    printSub: Subscription;
    patientSub: Subscription;
    imgQueueLoading: number = 0;

    constructor(
        public printSvc: PrintService
    ) { }

    ngOnInit() {

        this.printSvc.contentReady = false;
        this.printSvc.hideSignatures.next(true);

        this.patientSub = this.printSvc.activePatient.subscribe(
            (patient: any) => {
                this.patient = patient;
            }
        )

        this.printSub = this.printSvc.toPrintData.subscribe(
            (printData: any) => {
                if (printData && printData.assessment) {
                    this.assessment = printData.assessment;
                    const rawJson = this.assessment.consentJson ?? this.assessment.consent_json;
                    this.assessJSON = typeof rawJson === 'string'
                        ? JSON.parse(rawJson)
                        : (rawJson || {});

                    const staffPath = this.assessment.signatureUrl ?? this.assessment.signature_url;
                    const guardianPath = this.assessment.guardianSignatureUrl ?? this.assessment.guardian_sig_url;
                    if (staffPath) {
                        this.loadSignature(`${this.base_url}/files/${staffPath}`);
                    }
                    if (guardianPath) {
                        this.loadSignature(`${this.base_url}/files/${guardianPath}`);
                    }

                }
            }
        );

    }

    ngOnDestroy() {
        this.printSub.unsubscribe();
        this.patientSub.unsubscribe();
    }

    print() {
        if (this.imgQueueLoading <= 0) {
            this.printSvc.contentReady = true;
        }
    }
    // load signature
    loadSignature(src: string) {
        this.imgQueueLoading += 1;
        const img = new Image();
        img.onload = (e) => {
            this.imgQueueLoading -= 1;
            setTimeout(() => { this.print(); }, 10)
            // this.printSvc.contentReady = true;
        }
        img.onerror = (e) => {
            this.imgQueueLoading -= 1;
            setTimeout(() => { this.print(); }, 10)
            // this.printSvc.contentReady = true;
        }
        img.src = src;
    }

}
